import { type CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import {
  policyFooterStyle,
  policyLinkStyle,
} from '#src/assets/ui/shared/styles.ts'
import { type SiteConfig } from '~/src/models/site-configs/siteConfigs.ts'

export function CookieConsentFooter({
  t,
  siteConfig,
}: {
  t: CookieConsentTranslator
  siteConfig: SiteConfig
}) {
  if (!siteConfig.cookiePolicyUrl) {
    return null
  }

  return (
    <div style={policyFooterStyle}>
      <a
        href={siteConfig.cookiePolicyUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={policyLinkStyle}
      >
        {t('cookiePolicy')}
      </a>
    </div>
  )
}
